// extracted by mini-css-extract-plugin
export var errorIcon = "_n5-1";
export var nameLogo = "_n5-0";